import { connect } from 'react-redux';
import Tips from '../../components/tips';
import * as Selector from './selectors';

export default connect(
    state => ({
        tips: Selector.getTips(state)
    })
)(Tips);